import React from 'react';
import './BidCard.css';

const BidCard = ({
    amount_payable_to_provider,
    discount_amount,
    bid_detail_pdf,
    bid_amount,
    hours,
    total_amount,
    bid_type,
    bid_detail_text
}) => {
    if (bid_amount === 0) {
        return (
            <div className="bid-card bid-card--pending">
                <h3 className="bid-card__heading">Bid Details:</h3>
                <div className="bid-card__info">
                    <img src="/assets/images/New-files/information-circle-outline.png" alt="" />
                    <span>We will notify and update the project bid information as soon as the provider confirms the project.</span>
                </div>
            </div>
        );
    }

    return (
        <div className="bid-card">
            <h3 className="bid-card__heading">Bid Details:</h3>
            
            {bid_type === "hourly" ? (
                <div className="bid-card__details">
                    <div className="bid-card__row">
                        <span>Bid Amount (Hourly):</span>
                        <span>${bid_amount}</span>
                    </div>
                    <div className="bid-card__row">
                        <span>Total Number of Hours:</span>
                        <span>{hours} Hours</span>
                    </div>
                    <div className="bid-card__row">
                        <span>Total Payable:</span>
                        <span>${total_amount}</span>
                    </div>
                </div>
            ) : (
                <div className="bid-card__row">
                    <span>Bid Amount:</span>
                    <span>${total_amount}</span>
                </div>
            )}

            {discount_amount !== 0 && (
                <div className="bid-card__row bid-card__row--discount">
                    <span>Discount applied!</span>
                    <span>-${discount_amount}</span>
                </div>
            )}

            <div className="bid-card__row bid-card__row--total">
                <span>Amount Payable to Provider</span>
                <span>${amount_payable_to_provider}</span>
            </div>

            {bid_detail_text && (
                <div className="bid-card__breakdown">
                    <h4>Bid Breakdown</h4>
                    <p>{bid_detail_text}</p>
                </div>
            )}

            {bid_detail_pdf?.document?.url && (
                <button 
                    className="bid-card__document"
                    onClick={() => window.open(bid_detail_pdf.document.url, '_blank')}
                >
                    <div className="bid-card__document-info">
                        <img src="/assets/images/New-files/attachment-icon.svg" alt="attachment" />
                        <span>Proposal Document</span>
                    </div>
                    <span className="bid-card__document-action">View</span>
                </button>
            )}
        </div>
    );
};

export default BidCard;